import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Drawer, App } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { ReactComponent as Burger } from '../../Icons/Burger.svg';
import { ReactComponent as Basket } from '../../Icons/Basket.svg';
import { ReactComponent as Favorite } from '../../Icons/Like.svg';
// import { ReactComponent as Statistick } from '../../Icons/Statistick.svg';
import { ReactComponent as Logo } from '../../Icons/Logo.svg';
import { ReactComponent as LogoName } from '../../Icons/LogoName.svg';
import Catalog from '../Catalog';
import cl from './header.module.css';
import { useHttp } from '../../Hooks/Http.hook';
import useWindowDimensions from '../../Hooks/WindowDimensions';
import articles from '../../Data/articles';
import ChangeCity from '../ChangeCity';
import Search from '../Search';

const Header = () => {
    const [isShow, setIsShow] = useState(false);
    const [categories, setCategories] = useState([]);
    const [publications, setPublications] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPubl, setIsLoadingPubl] = useState(false);
    const phone = useSelector((state) => state.phone).items ?? '';
    const [isOpenedDrawerSearch, setIsOpenedDrawerSearch] = useState(false);
    const { notification } = App.useApp();
    const { width } = useWindowDimensions();
    const { request } = useHttp(false);
    const basket = useSelector((state) => state.basket)?.items ?? [];

    const { pathname } = useLocation();

    const onClickHandler = () => {
        setIsShow((iS) => !iS);
        document.body.classList.toggle('lock-scroll');
    };

    useEffect(() => {
        const getAllCategories = async () => {
            setIsLoading(true);

            await request('/api/category', 'GET')
                .then((res) => {
                    if (res.data) {
                        setCategories(res.data);
                    } else if (res.error) {
                        notification.error({ message: res.error.message });
                    }
                })
                .catch(() =>
                    notification.error({
                        message:
                            'Ошибка сервера. Попробуйте перезагрузить страницу.',
                    })
                )
                .finally(() => setIsLoading(false));
        };

        const getPartners = async (el) => {
            await request(`/api/article/${el.key}?page1&perPage=10`, 'GET')
                .then((res) => {
                    if (res.data) {
                        setPublications((prev) => ({
                            ...prev,
                            [el.key]: {
                                data: res.data.articles ?? [],
                                title: el.title,
                            },
                        }));
                    } else if (res.error) {
                        notification.error({ message: res.error.message });
                    }
                })
                .catch(() =>
                    notification.error({
                        message:
                            'Ошибка сервера. Попробуйте перезагрузить страницу.',
                    })
                );
        };

        getAllCategories();
        articles.forEach(async (item, index) => {
            if (index === 0) {
                setIsLoadingPubl(true);
            }
            await getPartners(item);
            if (index === articles.length - 1) {
                setIsLoadingPubl(false);
            }
        });
    }, []);
    return (
        <>
            <div className={cl.header}>
                <Row className={cl.headerContent}>
                    {width >= 1440 ? (
                        <Link
                            to="/"
                            onClick={() => setIsShow(false)}
                            className={cl.logoName}
                        >
                            <LogoName />
                        </Link>
                    ) : (
                        <Link
                            to="/"
                            onClick={() => setIsShow(false)}
                            className={cl.logo}
                        >
                            <Logo />
                        </Link>
                    )}

                    <Button
                        type="primary"
                        className={cl.catalog}
                        onClick={onClickHandler}
                    >
                        {isShow ? (
                            <CloseOutlined className={cl.closeIcon} />
                        ) : (
                            <Burger />
                        )}
                        {width >= 768 ? 'Каталог' : null}
                    </Button>

                    {width >= 992 ? (
                        <Search />
                    ) : (
                        <SearchOutlined
                            className={cl.searchIcon}
                            onClick={() => setIsOpenedDrawerSearch(true)}
                        />
                    )}

                    <Drawer
                        width="100%"
                        height={68}
                        style={{
                            background: 'var(--primary-gray)',
                            overflow: 'hidden',
                        }}
                        title={<Search />}
                        placement="top"
                        closeIcon={
                            <CloseOutlined
                                className={cl.searchIcon}
                                style={{ color: 'var(--primary-yellow)' }}
                            />
                        }
                        open={isOpenedDrawerSearch}
                        onClose={() => setIsOpenedDrawerSearch(false)}
                    />

                    <Row className={cl.panelAction}>
                        {/* <Statistick /> */}

                        <Link to="/favorite">
                            <Favorite
                                className={`${cl.likeIcon} ${
                                    pathname === '/favorite'
                                        ? cl.likeIconFilled
                                        : ''
                                }`}
                            />
                        </Link>

                        <div className={cl.basket}>
                            <Link to="/basket">
                                <Basket
                                    className={`${cl.likeIcon} ${
                                        cl.basketIcon
                                    } ${
                                        pathname === '/basket'
                                            ? cl.basketIconFilled
                                            : ''
                                    }`}
                                />
                            </Link>
                            {basket.length > 0 && (
                                <span className={cl.basketCount}>
                                    +{basket.length}
                                </span>
                            )}
                        </div>

                        <Col className={cl.contact}>
                            <a
                                href={`tel:${
                                    phone.match(/^\d+/) || '+79818218340'
                                }`}
                            >
                                <Col className={cl.phone}>
                                    {phone || '+79818218340'}
                                </Col>
                            </a>
                            <ChangeCity className={cl.city} />
                            {/* <Row className={cl.city}>Санкт-Петербург</Row> */}
                        </Col>
                    </Row>
                </Row>
            </div>
            <div
                className={`main-page ${isShow ? cl.headerCatalog : ''}`}
                style={{ paddingTop: 0 }}
            >
                {isShow && (
                    <div className={cl.catalogContainerBack}>
                        <div className={cl.catalogContainer}>
                            <Catalog
                                categories={categories}
                                isLoading={isLoading}
                                isLoadingPubl={isLoadingPubl}
                                setIsShow={setIsShow}
                                width={width}
                                publications={publications}
                                initDataKey={articles}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Header;
